export interface CanonicalPresentationRecord {
  status?: string | null;
  display_status?: string | null;
  status_group?: string | null;
}

const titleText = (value?: string | null): string =>
  String(value || '')
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

export const canonicalStatusLabel = (
  record?: CanonicalPresentationRecord | null,
  fallback = '-',
): string => (
  record?.display_status
  || titleText(record?.status)
  || fallback
);

export const canonicalStatusKey = (
  record?: CanonicalPresentationRecord | null,
): string => (
  record?.status_group
  || record?.status
  || ''
);
